export const facebookScript = function (callback) {
  window.fbAsyncInit = function () {
    FB.init({
      appId: 'TODO:APPID',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v17.0'
    })
  };
  (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    const js = d.createElement(s)
    js.id = id
    js.async = true
    js.defer = true
    js.crossorigin = 'anonymous'
    js.src = 'https://connect.facebook.net/nl_NL/sdk.js'
    js.onload = () => {
      console.log('✔ Facebook script loaded')
      callback()
    }
    js.onerror = () => {
      throw new Error('Facebook script failed to load')
    }
    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')
}

export const twitterScript = function (callback) {
  window.twttr = (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0]
    const t = window.twttr || {}
    if (d.getElementById(id)) { return t }
    const js = d.createElement(s)
    js.id = id
    js.src = 'https://platform.twitter.com/widgets.js'
    fjs.parentNode.insertBefore(js, fjs)

    t._e = []
    t.ready = (f) => {
      console.log('✔ Twitter script loaded')
      t._e.push(f)
      callback()
    }

    return t
  }(document, 'script', 'twitter-wjs'))
}
